import React from 'react';
import { useSelector } from 'react-redux';
import { Box, useTheme } from '@chakra-ui/react';

import LoadingSpinner from '../../../../components/Spinner';
import { selectAdminPageUsers, selectAreUsersLoading } from '../../../../redux/modules/adminPage';
import { getContentHeightString, PagePadding } from '../../../../styles/layoutDimensions';
import AdminSearchPanel from '../AdminSearchPanel';

import UserRow from './components/UserRow';

function UsersTabPanel() {
  const allUsers = useSelector(selectAdminPageUsers);
  const areUsersLoading = useSelector(selectAreUsersLoading);
  const theme = useTheme();

  const searchFunction = (searchData, search) => (
    searchData.filter(d => d.userFirstName.toLowerCase().includes(search)
      || d.userLastName.toLowerCase().includes(search))
  );

  const displayUserRow = users => users.map(user => <UserRow key={user.userId} user={user} />);

  if (!allUsers || areUsersLoading) return <LoadingSpinner />;

  return (
    <Box
      maxHeight={getContentHeightString(`${theme.space[PagePadding]} * 4`, '40px')}
      mt={7}
      overflowY="auto"
    >
      <AdminSearchPanel
        allActive={allUsers.filter(user => user.isActive === true)}
        allData={allUsers}
        allInactive={allUsers.filter(user => user.isActive === false)}
        rowFunction={displayUserRow}
        searchFunction={searchFunction}
        sortFunction={((a, b) => b.isActive - a.isActive)}
        tabName="user"
      />
    </Box>
  );
}

export default UsersTabPanel;
